module.exports = __webpack_public_path__ + "6758bc3b39c15ac5b2c551089f1481f0.MP3";